<div class="d-flex justify-content-between flex-column flex-md-row">
	<div class="d-flex flex-row">
		<mat-icon class="mr-3" *ngIf="icon.length > 0">{{ icon }}</mat-icon>
		<app-page-heading class="heading" heading="{{ heading }}" theme="{{ theme }}"></app-page-heading>
		<app-tooltip class="tooltip-in-label" *ngIf="showTip && heading" [tooltip]="toolTip"></app-tooltip>
	</div>
	<ng-content></ng-content>
</div>
<hr class="page-title-underline" />
